import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import { default as PlatformInlineEdit } from '@atlaskit/inline-edit';

export type InlineEditProps = Omit<
	React.ComponentProps<typeof PlatformInlineEdit>,
	'validate' | 'analyticsContext' | 'readView' | 'editView'
> & { children: React.ReactNode };

const noop = () => {};

export const InlineEdit = (props: Parameters<RenderFn>[0]) => {
	const {
		startWithEditViewOpen = false,
		keepEditViewOpenOnBlur = false,
		hideActionButtons = false,
		isRequired = false,
		readViewFitContainerWidth = false,
		editButtonLabel = 'Edit',
		confirmButtonLabel = 'Confirm',
		cancelButtonLabel = 'Cancel',
		defaultValue,
		isEditing,
		onConfirm: providedOnConfirm = noop,
		onCancel: providedOnCancel = noop,
		onEdit: providedOnEdit = noop,
	} = props.forgeDoc.props as InlineEditProps;

	const readViewForgeDoc = props.forgeDoc.children.find((child) => {
		if (child.type === 'ContentWrapper' && child.props?.name === 'readView') {
			return child;
		}
	});
	const editViewForgeDoc = props.forgeDoc.children.find((child) => {
		if (child.type === 'ContentWrapper' && child.props?.name === 'editView') {
			return child;
		}
	});

	return (
		<PlatformInlineEdit
			startWithEditViewOpen={startWithEditViewOpen}
			keepEditViewOpenOnBlur={keepEditViewOpenOnBlur}
			hideActionButtons={hideActionButtons}
			isRequired={isRequired}
			readViewFitContainerWidth={readViewFitContainerWidth}
			editButtonLabel={editButtonLabel}
			confirmButtonLabel={confirmButtonLabel}
			cancelButtonLabel={cancelButtonLabel}
			defaultValue={defaultValue}
			isEditing={isEditing}
			readView={() => readViewForgeDoc?.children.map(props.render)}
			editView={() => editViewForgeDoc?.children.map(props.render)}
			onConfirm={providedOnConfirm}
			onCancel={providedOnCancel}
			onEdit={providedOnEdit}
		/>
	);
};
